import { render } from "./Licences.vue?vue&type=template&id=cccd468a&scoped=true"
import script from "./Licences.vue?vue&type=script&lang=js"
export * from "./Licences.vue?vue&type=script&lang=js"

import "./Licences.vue?vue&type=style&index=0&id=cccd468a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccd468a"]])

export default __exports__